__webpack_require__.p = "/tokens-scale-badge/referrals-hub/";